export enum ToastType {
    SUCCESS = 'success',
    INFO = 'info',
    WARN = 'warn',
    ERROR = 'error',
    CUSTOM = 'custom',
}